import { breakpoints } from './breakpoints'
import { css } from './themedStyledComponents'

export const media = {
  onlyMobile: (strings: TemplateStringsArray, ...args) => css`
    @media (max-width: ${breakpoints.tablet - 1}px) {
      ${css(strings, ...args)};
    }
  `,
  tablet: (strings: TemplateStringsArray, ...args) => css`
    @media (min-width: ${breakpoints.tablet}px) {
      ${css(strings, ...args)};
    }
  `,
  upToDesktop: (strings: TemplateStringsArray, ...args) => css`
    @media (max-width: ${breakpoints.desktop - 1}px) {
      ${css(strings, ...args)};
    }
  `,
  desktop: (strings: TemplateStringsArray, ...args) => css`
    @media (min-width: ${breakpoints.desktop}px) {
      ${css(strings, ...args)};
    }
  `,
  upToLargeDesktop: (strings: TemplateStringsArray, ...args) => css`
    @media (max-width: ${breakpoints.largeDesktop - 1}px) {
      ${css(strings, ...args)};
    }
  `,
  largeDesktop: (strings: TemplateStringsArray, ...args) => css`
    @media (min-width: ${breakpoints.largeDesktop}px) {
      ${css(strings, ...args)};
    }
  `,
}
